__turbopack_context__.v({
  "background_image": "styles-module-scss-module__T4Kgsq__background_image",
  "img": "styles-module-scss-module__T4Kgsq__img",
  "layout_is_fill": "styles-module-scss-module__T4Kgsq__layout_is_fill",
});
